import BaseService from './BaseService'
import Product from '@/models/Product'

export default class ProductService extends BaseService<Product> {
  protected subdomain = 'products'

  model() {
    return Product
  }

  constructor(locationId: string) {
    super(locationId)
  }
}
